import { render, staticRenderFns } from "./Last.vue?vue&type=template&id=38c25beb&scoped=true&"
import script from "./Last.vue?vue&type=script&lang=js&"
export * from "./Last.vue?vue&type=script&lang=js&"
import style0 from "./Last.vue?vue&type=style&index=0&id=38c25beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c25beb",
  null
  
)

export default component.exports